import { render, staticRenderFns } from "./LKTextFieldAteFormdataStartedModal.vue?vue&type=template&id=0c77f47e&"
import script from "./LKTextFieldAteFormdataStartedModal.vue?vue&type=script&lang=js&"
export * from "./LKTextFieldAteFormdataStartedModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports